import React from 'react';
import { 
  Card, 
  CardContent, 
  Typography, 
  Box, 
  Chip,  
  Divider 
} from '@mui/material';
import { CheckCircleOutline } from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';

const ActionCard = ({ item, fromScreen }) => {
  const navigate = useNavigate();

  const setBackGroundColorForActionType = (category) => {
    if (category === 'Listing') {
      return '#4CAF50';
    } else if (category === 'Contact') {
      return '#9c9b96';
    } else {
      return "orange";
    }
  };
  const handleCardClick = () => {
    navigate(`/actions/${item.actionID}`, { 
      state: { 
        actionID: item.actionID, 
        fromScreen: fromScreen 
      } 
    });
  };

  return (
    <Card 
      sx={{
        mb: 1.5,
        cursor: 'pointer',
        '&:hover': {
          boxShadow: 3,
        },
      }}
      onClick={handleCardClick}
    >
      <CardContent sx={{ p: 1.25 }}>
        <Box 
          sx={{ 
            display: 'flex', 
            justifyContent: 'space-between', 
            alignItems: 'center',
            mb: 1,
            width: '100%' 
          }}
        >
          {item.DateDue && (
            <Typography variant="caption" sx={{ fontSize: 12 }}>
              Due: <strong>{item.DateDue}</strong>
              {item.Complete === 1 && (
                <CheckCircleOutline 
                  sx={{ 
                    fontSize: 14, 
                    color: '#228B22', 
                    ml: 0.5,
                    verticalAlign: 'middle' 
                  }} 
                />
              )}
            </Typography>
          )}
          {item.Category && (
            <Chip
              label={item.Category.toUpperCase()}
              sx={{
                backgroundColor: setBackGroundColorForActionType(item.Category),
                color: 'white',
                fontWeight: 'bold',
                fontSize: 10,
                height: 20,
                '& .MuiChip-label': {
                  px: 0.75,
                  py: 0.25,
                },
              }}
            />
          )}
        </Box>
        
        <Divider sx={{ mb: 1 }} />
        
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 0.5 }}>
          {item.propertyAddress && (
            <Typography variant="body2">
              <strong>Property Address: </strong>
              {item.propertyAddress}
            </Typography>
          )}
          
          {item.contactName && (
            <Typography variant="body2">
              <strong>Contact Name: </strong>
              {item.contactName}
            </Typography>
          )}
          
          {item.contactPhoneNumber && (
            <Typography variant="body2">
              <strong>Phone: </strong>
              {item.contactPhoneNumber}
            </Typography>
          )}
          
          {item.details && (
            <Typography variant="body2">
              <strong>Details: </strong>
              {item.details}
            </Typography>
          )}
        </Box>
      </CardContent>
    </Card>
  );
};

export default ActionCard;